var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMessageInvisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.62156 6.9353C5.5687 6.9353 2.2832 10.2208 2.2832 14.2737V31.8857C2.2832 35.9386 5.5687 39.2241 9.62156 39.2241H10.8565V43.129C10.8565 44.6094 12.4963 45.5015 13.7392 44.6973L21.4235 39.7251C21.6437 39.5826 21.8187 39.412 21.9516 39.2241H43.378C47.4308 39.2241 50.7163 35.9386 50.7163 31.8857V14.2737C50.7163 10.2208 47.4308 6.9353 43.378 6.9353H9.62156Z",
    fill: "url(#paint0_linear_7240_23889)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7240_23889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.94 29.94C30.2306 31.243 28.1491 31.9649 26 32C19 32 15 24 15 24C16.2439 21.6819 17.9691 19.6566 20.06 18.06M23.9 16.24C24.5883 16.0789 25.2931 15.9984 26 16C33 16 37 24 37 24C36.393 25.1356 35.6691 26.2048 34.84 27.19M28.12 26.12C27.8454 26.4148 27.5141 26.6512 27.1462 26.8151C26.7782 26.9791 26.3809 27.0673 25.9781 27.0744C25.5753 27.0815 25.1752 27.0074 24.8016 26.8565C24.4281 26.7056 24.0887 26.4811 23.8038 26.1962C23.519 25.9113 23.2944 25.572 23.1435 25.1984C22.9926 24.8249 22.9185 24.4247 22.9256 24.0219C22.9327 23.6191 23.0209 23.2219 23.1849 22.8539C23.3488 22.4859 23.5853 22.1547 23.88 21.88",
    stroke: "url(#paint1_linear_7240_23889)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 13L37 35",
    stroke: "url(#paint2_linear_7240_23889)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7240_23889",
    x1: 2.2832,
    y1: 9.87067,
    x2: 44.1121,
    y2: 40.6917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC32E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF80CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7240_23889",
    x1: 26,
    y1: 16,
    x2: 26,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFFBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7240_23889",
    x1: 26,
    y1: 13,
    x2: 26,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFFBD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7240_23889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(14 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessageInvisible);
export default __webpack_public_path__ + "static/media/icon_message_invisible.d1a9dbe54413d13d1a61f42e87934065.svg";
export { ForwardRef as ReactComponent };